module.exports = __webpack_public_path__ + "static/media/profile-kristin.8c12c017.jpg";